// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__CWa3-","content":"RecentSearches_content__3IINX"};